
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M8.25 10.5v6H9a3 3 0 010 6h12a3 3 0 010-6h.75a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5zM.75 10.5a6 6 0 006 6h1.5v-6z"}}),_c('rect',{staticClass:"a",attrs:{"x":"14.25","y":"1.5","width":"6","height":"6","rx":"1","ry":"1"}}),_c('path',{staticClass:"a",attrs:{"d":"M14.25 4.5H4.5"}})])
          )
        }
      }
    